import cookies from './cookies';

const AUTHENTICATED_USER_QUERY = `
  query AuthenticatedUser {
    authenticatedUser {
      email
      firstName
      fullName
      id
      lastName
      isEmployee
      isRepOrAssistant
      isRepAssistant
      isRmcRep
      isRepNoDealerQuote
    }
  }
`;

const AUTHENTICATED_USER_UPDATED_EVENT = 'threeform-authenticated-user-updated';

let authenticatedUser = null;

const getEndpoint = () => {
  const endpointMetaTag = document.querySelector(
    'meta[name="threeform-api-graphql-url"]'
  );

  return endpointMetaTag && endpointMetaTag.content;
};

const hasThreeformSessionCookie = () => {
  return Boolean(cookies.getCookie('3formSession'));
};

const dispatchAuthenticatedUserUpdated = () => {
  window.dispatchEvent(
    new CustomEvent(AUTHENTICATED_USER_UPDATED_EVENT, {
      detail: authenticatedUser,
    })
  );
};

const setAuthenticatedUser = user => {
  authenticatedUser = user;
  dispatchAuthenticatedUserUpdated();
  return authenticatedUser;
};

const getAuthenticatedUser = () => {
  return authenticatedUser;
};

const hasAuthenticatedUser = () => {
  return Boolean(authenticatedUser) || hasThreeformSessionCookie();
};

const fetchAuthenticatedUser = () => {
  const endpoint = getEndpoint();

  if (!endpoint) return Promise.resolve(null);

  return fetch(endpoint, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: AUTHENTICATED_USER_QUERY,
      operationName: 'AuthenticatedUser',
      variables: {},
    }),
  })
    .then(response => response.json())
    .then(responseData => {
      const nextAuthenticatedUser =
        responseData &&
        responseData.data &&
        responseData.data.authenticatedUser;

      return setAuthenticatedUser(nextAuthenticatedUser || null);
    })
    .catch(error => {
      console.error('Unable to bootstrap 3form session.', error);
      return null;
    });
};

const bootstrapThreeformSession = () => {
  if (hasThreeformSessionCookie())
    return Promise.resolve(getAuthenticatedUser());

  return fetchAuthenticatedUser();
};

export default {
  bootstrapThreeformSession,
  fetchAuthenticatedUser,
  getAuthenticatedUser,
  hasAuthenticatedUser,
  hasThreeformSessionCookie,
  AUTHENTICATED_USER_UPDATED_EVENT,
};
